/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AppointmentNote } from './AppointmentNote';
import {
    AppointmentNoteFromJSON,
    AppointmentNoteFromJSONTyped,
    AppointmentNoteToJSON,
} from './AppointmentNote';

/**
 * 
 * @export
 * @interface AppointmentNoteDraft
 */
export interface AppointmentNoteDraft {
    /**
     * 
     * @type {string}
     * @memberof AppointmentNoteDraft
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentNoteDraft
     */
    patient_id: string;
    /**
     * 
     * @type {string}
     * @memberof AppointmentNoteDraft
     */
    author_id?: string;
    /**
     * 
     * @type {number}
     * @memberof AppointmentNoteDraft
     */
    date?: number;
    /**
     * 
     * @type {AppointmentNote}
     * @memberof AppointmentNoteDraft
     */
    note: AppointmentNote;
}

/**
 * Check if a given object implements the AppointmentNoteDraft interface.
 */
export function instanceOfAppointmentNoteDraft(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "patient_id" in value;
    isInstance = isInstance && "note" in value;

    return isInstance;
}

export function AppointmentNoteDraftFromJSON(json: any): AppointmentNoteDraft {
    return AppointmentNoteDraftFromJSONTyped(json, false);
}

export function AppointmentNoteDraftFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentNoteDraft {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'patient_id': json['patient_id'],
        'author_id': !exists(json, 'author_id') ? undefined : json['author_id'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'note': AppointmentNoteFromJSON(json['note']),
    };
}

export function AppointmentNoteDraftToJSON(value?: AppointmentNoteDraft | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'patient_id': value.patient_id,
        'author_id': value.author_id,
        'date': value.date,
        'note': AppointmentNoteToJSON(value.note),
    };
}

